<template>
  <row
    @click="$emit('click')" :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null]"
    role="listitem"
    v-ripple
    :tag="tag"
    :to="to">
    <slot />
  </row>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ListItem',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('list-item', ['transition-colors', 'duration-500', 'ease-in-out', 'outline-none'])
    }
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    to: {
      type: String
    },
    disabled: {
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/list-item/list-item.vue